module.exports = __webpack_public_path__ + "img/result-loan-user.d5fffe39.png";